import { PromoMeta } from '~/services/PromoService';

export type VoucherRewardKindOptionMeta = PromoMeta['voucher_reward_kind_options'][number];

/** Reward kinds that may be chosen on create/edit (`showInAdmin` from promo meta). */
export function filterVoucherRewardKindOptionsForAdmin(
  meta: PromoMeta | null | undefined,
): Array<VoucherRewardKindOptionMeta> {
  return (meta?.voucher_reward_kind_options ?? []).filter((option) => option.showInAdmin);
}

/** All catalog entries by `key` (includes `showInAdmin: false`) for labelling saved vouchers / logs. */
export function voucherRewardKindOptionByKey(
  meta: PromoMeta | null | undefined,
): Map<string, VoucherRewardKindOptionMeta> {
  const map = new Map<string, VoucherRewardKindOptionMeta>();
  (meta?.voucher_reward_kind_options ?? []).forEach((option) => {
    map.set(option.key, option);
  });
  return map;
}

/** When promo meta has not loaded yet or returned no voucher reward kinds. */
export const FALLBACK_VOUCHER_REWARD_KIND_OPTIONS: Array<VoucherRewardKindOptionMeta> = [
  { key: 'discount', name: 'Discount', showInAdmin: true },
  { key: 'provide_credit', name: 'Credit on purchase', showInAdmin: true },
];
